var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockchainimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 520,
    viewBox: "0 0 720 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 520,
    fill: "#E6F1FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_4186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.707 150.707H353.704V249.058H364.411V202.559H414.968V191.852H364.411V140H250V249.058H260.707V150.707Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.707 276.295H364.208V265.589H312.559V215.621H301.852V265.589H250V380H364.208V369.293H260.707V276.295Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.024 369.293H389.026V270.942H378.319V317.441H326.456V328.148H378.319V380H492.73V270.942H482.024V369.293Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.522 140V150.707H482.024V243.704H378.522V254.411H430.171V304.379H440.878V254.411H492.73V140H378.522Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.94 220.824H285.471V177.355H328.94V220.824ZM296.178 210.118H318.233V188.062H296.178V210.118ZM330.825 344.529H287.356V301.06H330.825V344.529ZM298.062 333.822H320.118V311.767H298.062V333.822ZM457.259 342.645H413.79V299.176H457.259V342.645ZM424.497 331.938H446.553V309.882H424.497V331.938ZM455.375 218.94H411.906V175.471H455.375V218.94ZM422.613 208.233H444.668V186.178H422.613V208.233Z",
    fill: "#7C9299"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_4186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242.73,
    height: 240,
    fill: "white",
    transform: "translate(250 140)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainimg);
export default __webpack_public_path__ + "static/media/blockchainimg.2b7463a448131138cbeaa2f6cec034ad.svg";
export { ForwardRef as ReactComponent };